import { render } from "./Reset.vue?vue&type=template&id=5b2b7ad9&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import "./Reset.vue?vue&type=style&index=0&id=5b2b7ad9&scoped=true&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2b7ad9"]])

export default __exports__